import { getLoaderClass } from "./loader.styles";
import type { LoaderProps } from "./loader.types";

export function Loader({ className, ...props }: LoaderProps) {
  return <span data-testid="loader" className={getLoaderClass({ className })} {...props} />;
}
